import React from "react";

import { Card, CardContent, Typography } from "@mui/material";

import "./RecognitionDirectAtCard.css";

export default function RecognitionDirectAtCard({
  title,
  avatarImage,
  onClick = () => {},
}) {
  return (
    <Card variant="outlined" onClick={onClick}>
      <CardContent
        className="card-content"
        sx={{
          "&:last-child": {
            paddingBottom: "var(--spacing-4x)",
          },
          padding: "var(--spacing-4x)",
        }}
      >
        <img
          src={avatarImage}
          alt="avatar"
          className="direct-at-avatar-image"
        />
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontSize: 10,
          }}
        >
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
}
